import React, { Component } from "react";
import { Row, Col, Container } from 'react-bootstrap'
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import MeatrialAssigning_to_Students from "../components/MaterialBookSending/materials_Assigning/materials_Assigning";
import { MaterialAssignShimmer } from "../components/MaterialBookSending/materials_Assigning/MaterialAssignShimmer";
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";

const GET_STUDENT_DETAILS = gql`
query($institute_id:Int){
    getNewEducationalStudents(institute_id: $institute_id) {
        roll_no
        student_name
        class_id
        class_name
        branch_id
        branch_name
        section_id
        section_name
        parent_name
        parent_mobile
        parent_password
        student_id
      }
}
`

const GET_MATERIAL_TYPES = gql`
query($id:Int){
    getMaterialTypes(id:$id){
        id
        material_type
        is_grouping
      }
   }
`;


class MeatrialAssigning extends Component {
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };
    render() {
        if (Cookies.get("token") == undefined) this.props.history.push("/login");

        const getStudents = this.props.getStudents;
        const loading2 = getStudents.loading;
        const error2 = getStudents.error;

        if (error2 != undefined) {
            alert("Server Error", +error2.message);
            return null;
        }

        const getMaterialTypes = this.props.getMaterialTypes;
        const loading3 = getMaterialTypes.loading;
        const error3 = getMaterialTypes.error;

        if (error3 != undefined) {
            alert("Server Error", +error3.message);
            return null;
        }

        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">
                    <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
                        <SideNavbar onClick={() => this.menuToggler()} />
                    </div>
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper pt-0">
                        <Container fluid>
                            {
                                loading2 || loading3 ? (
                                    <MaterialAssignShimmer />
                                ) : (
                                    <MeatrialAssigning_to_Students
                                        getStudents={getStudents.getNewEducationalStudents}
                                        getMaterialTypes={getMaterialTypes.getMaterialTypes}
                                    />
                                )
                            }
                        </Container>
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}

export default withRouter(
    compose(
        graphql(GET_STUDENT_DETAILS, {
            options: (props) => ({
                variables: {
                    institute_id: parseInt(Cookies.get("institutionid")),
                },
            }),
            name: "getStudents",
        }),
        graphql(GET_MATERIAL_TYPES, {
            options: (props) => ({
                variables: {
                    id: parseInt(0),
                },
            }),
            name: "getMaterialTypes",
        }),
    )
        (MeatrialAssigning));
